import { filter } from 'rxjs/operators';
import { Component, OnInit, Inject } from '@angular/core';
import { MODAL_DATA_VAR } from "mis-design-system/mis-modal";
import { CONSTANTS_ASSETS_EMP_WEB_EXP } from "../../../constants/assets.constants";
import { ModalRef } from "mis-design-system/mis-modal";
import { NsEmpWebExpData } from '../../../models/emp-web-exp.model';
import { NsWISConfigurations } from '../../../models/configurations.model';
import { FormControl } from '@angular/forms';
import { ToastService } from 'mis-crystal-design-system/toast';
import { ApiService } from '../../../services/api.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'mis-employee-web-exp-meal-feedback-modal',
  templateUrl: './meal-feedback-modal.component.html',
  styleUrls: ['./meal-feedback-modal.component.scss']
})
export class MealFeedbackModalComponent implements OnInit {

  showLoader: boolean = false;
  Assets = CONSTANTS_ASSETS_EMP_WEB_EXP;
  modalData: NsEmpWebExpData.IMealFeedbackModalInfo;
  overallRating: number = 0;
  noOfStars: number = 5;
  mealFeedBackOptions: NsWISConfigurations.IMealFeedBackOptions;
  selectedImprovedOption: any = [];
  selectedLikedOption: any = [];
  mealRating: any = {};
  mealData: NsEmpWebExpData.IMealData[] = [];
  reviewData = new FormControl("");
  ratingType: any = {
    1: {
      name: 'Very Bad',
      asset: this.Assets.ICONS.HORRIBLE,
      feedBackOptionText: 'What can be improved?',
      feedBackOptionType: 'improvedOptions' 
    },
    2: {
      name: 'Bad',
      asset: this.Assets.ICONS.BAD,
      feedBackOptionText: 'What can be improved?',
      feedBackOptionType: 'improvedOptions'
    },
    3: {
      name: 'Average',
      asset: this.Assets.ICONS.AVERAGE,
      feedBackOptionText: 'What can be improved?',
      feedBackOptionType: 'improvedOptions'
    },
    4: {
      name: 'Good',
      asset: this.Assets.ICONS.GOOD,
      feedBackOptionText: 'What did you like the most?',
      feedBackOptionType: 'likedOptions'
    },
    5: {
      name: 'Excellent',
      asset: this.Assets.ICONS.EXCELLENT,
      feedBackOptionText: 'What did you like the most??',
      feedBackOptionType: 'likedOptions'
    }
  }
  constructor(
    @Inject(MODAL_DATA_VAR) data,
    private _modalRef: ModalRef,
    private _toast: ToastService,
    private _apiSvc: ApiService,
    private _translateSvc: TranslateService
  ) { 
    this.modalData = data;
    this.overallRating = this.modalData.overallRating;
    this.mealFeedBackOptions = this.modalData.mealFeedBackOptions;
    this.mealData = this.modalData.mealData;
  }

  ngOnInit(): void {
    this.mealData.forEach((item: NsEmpWebExpData.IMealData)=>{
      this.mealRating[item.mealId] = {
        mealRating: 0
      }
    })
  }

  overAllSelectedRating(event){
    event > 3 ? this.selectedImprovedOption = [] : this.selectedLikedOption = [];
    this.overallRating = event;
  }

  itemRating(event, mealId){
    this.mealRating[mealId].mealRating = event;
  }

  selectFeedBackOption(itemName, itemType : 'likedOptions' | 'improvedOptions'){
    if(itemType === 'likedOptions'){
      if(this.selectedLikedOption.length > 0 && this.selectedLikedOption.includes(itemName)){
        this.selectedLikedOption = this.selectedLikedOption.filter((item: any) => {
          return item !== itemName
        })
      }
      else{
        this.selectedLikedOption.push(itemName);
      }
    }
    else{
      if(this.selectedImprovedOption.length > 0 && this.selectedImprovedOption.includes(itemName)){
        this.selectedImprovedOption = this.selectedImprovedOption.filter((item: any) => {
          return item !== itemName
        })
      }
      else{
        this.selectedImprovedOption.push(itemName);
      }
    }
  }

  submitFeedback(){
    const feedBackData = [{
      bookingId: this.modalData.bookingId,
      overallRating: this.overallRating,
      options: {
        improvedOptions : this.selectedImprovedOption,
        likedOptions : this.selectedLikedOption
      },
      mealRating: this.mealRating,
      comment: this.reviewData.value.trim()
    }]
    this.showLoader = true;
    this._apiSvc.submitMealData(feedBackData).subscribe({
      next : (res: any) => {
        this._toast.displayMsg(`${this._translateSvc.instant('Feedback submitted')}`, 2000);
        this.showLoader = false;
        this.closeModal(true);
      },
      error: (err: any) => {
        this._toast.displayMsg(`${this._translateSvc.instant('Your feedback could not be submitted')}`, 2000);
        this.showLoader = false;
        this.closeModal(false);
      }
    })
  }

  closeModal(close: boolean = true){
    this._modalRef.close(close);
  }

}
